import React from "react";

// Define the notification type
interface Notification {
    id: number;
    title: string;
    message: string;
    createdAt: Date;
    image_url?: string; // Image URL for each notification
    video_url?: string; // Video is optional
}

interface AnnouncementsModalProps {
    notifications: Notification[];
    currentIndex: number;
    isModalOpen: boolean;
    onClose: () => void;
    onNext: () => void;
    onPrevious: () => void;
}

const AnnouncementsModal: React.FC<AnnouncementsModalProps> = ({
    notifications,
    currentIndex,
    isModalOpen,
    onClose,
    onNext,
    onPrevious,
}) => {
    if (!isModalOpen || notifications.length === 0) return null;

    const currentNotification = notifications[currentIndex];
    const notificationCount = notifications.length;
    const barWidthClass = `w-${1 / notificationCount}`;

    return (
        <>
            {/* Gray overlay behind the modal */}
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-40">
                {" "}
            </div>

            {/* Modal */}
            <div className="fixed flex flex-col top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-5 z-50 w-[300px] w-full md:w-1/2 h-screen overflow-y-auto md:rounded-lg">
                {/* Close Icon */}
                <div className="flex justify-center space-x-2 mb-4">
                    {notifications.map((_, index) => (
                        <div
                            key={index}
                            className={`h-1 w-1/2 rounded-full ${
                                index === currentIndex
                                    ? "bg-gold"
                                    : "bg-gray-300"
                            } ${barWidthClass}`}
                        />
                    ))}
                </div>

                <div className="flex-grow h-1/5 "></div>

                {/* Image for current notification */}

                <div className="flex flex-col justify-center items-center">
                    <h2 className="text-xl font-semibold mb-5">
                        {currentNotification.title}
                    </h2>
                    {currentNotification.video_url ? (
                        <video
                            autoPlay
                            loop
                            muted
                            controls
                            className="w-3/4 md:w-1/2 h-3/4 mb-4 rounded-lg"
                        >
                            <source
                                src={currentNotification.video_url}
                                type="video/mp4"
                            />
                            Votre navigateur ne supporte pas la lecture de
                            vidéos.
                        </video>
                    ) : currentNotification.image_url ? (
                        <img
                            src={currentNotification.image_url}
                            alt="Notification"
                            className="w-3/4 md:w-1/2 h-3/4 mb-4 rounded-lg"
                        />
                    ) : null}
                    <p className="text-base font-semibold">
                        {currentNotification.message}
                    </p>
                </div>
                <div className="flex-grow"></div>

                <div className="flex justify-between mt-2 w-full">
                    {currentIndex > 0 ? (
                        <button
                            onClick={onPrevious}
                            className="hover:bg-gray-200 rounded-full px-3 py-1 font-semibold"
                        >
                            Précédent
                        </button>
                    ) : (
                        <div className="px-3 py-1 text-white">Précédent</div> // Invisible placeholder
                    )}

                    <button
                        onClick={
                            currentIndex === notifications.length - 1
                                ? onClose
                                : onNext
                        }
                        className="bg-gold rounded-full text-black px-4 py-2 font-semibold"
                    >
                        {currentIndex === notifications.length - 1
                            ? "Terminer"
                            : "Suivant"}
                    </button>
                </div>
            </div>
        </>
    );
};

export default AnnouncementsModal;
